import { ROUTES_EMPLOYEES } from '@/app/data/route_constants';

const routesSales = [
  {
    name: ROUTES_EMPLOYEES.PROJECT_SALES_UNITS,
    path: 'units',
    component: () => import('@/app/_employees/subpages/sales/SalesUnitsPage.vue'),
    props: true,
  },
  {
    name: ROUTES_EMPLOYEES.PROJECT_SALES_TICKETS,
    path: 'tickets',
    component: () => import('@/app/_employees/subpages/sales/SalesTicketsPage.vue'),
    props: true,
  },
  {
    name: ROUTES_EMPLOYEES.PROJECT_SALES_DOCUMENTS,
    path: 'documents',
    component: () => import('@/app/_employees/subpages/sales/SalesDocumentsPage.vue'),
    props: true,
  },
];

export default routesSales;
